export default __webpack_public_path__ + "static/media/main.161ce7b1.jpg";